import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  sivi: [],
  selectedAFDMessages: [],
  selectedCustomerId: false,
  selectedCustomer: false,
  chosenPackage: "",
  newCustomerData: {},
  currentPackages: {},
  linkOptions: {},
  packageMessageLinkOptions: { placeholder: "Selecteer eerst een klant" },
  foundCustomers: {},
  linkGroupedMessagesToPolicies: {},
  attachmentAgencies: {},
  linkAttachmentsToAgencyCategory: {},
  saveMessageAttachments: {},

  perPageOptions: [5, 10, 15, 25, 50, 100],

  fetchingPaginatedUnprocessedPackageMessages: false,
  paginatedUnprocessedPackageMessages: [],
  paginatedUnprocessedPackageMessagesCurrentRequestData: [],
  paginatedUnprocessedPackageMessagesOrder: "desc",
  paginatedUnprocessedPackageMessagesOrderBy: "datetime",
  paginatedUnprocessedPackageMessagesPage: 1,
  paginatedUnprocessedPackageMessagesPerPage: 15,
  selectedUnprocessedPackageMessages: [],
  unprocessedPackageMessageCount: 0,

  fetchingPaginatedUnprocessedPolicyMessages: false,
  paginatedUnprocessedPolicyMessages: [],
  paginatedUnprocessedPolicyMessagesCurrentRequestData: [],
  selectedUnprocessedPolicyMessages: [],
  paginatedUnprocessedPolicyMessagesOrder: "desc",
  paginatedUnprocessedPolicyMessagesOrderBy: "datetime",
  paginatedUnprocessedPolicyMessagesPage: 1,
  paginatedUnprocessedPolicyMessagesPerPage: 15,
  unprocessedPolicyMessageCount: 0,

  packageMessageFilters: [],
  policyMessageFilters: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
